/**
 * Returns a new function that, when invoked, invokes `func` at most once per `wait` milliseconds.
 * Taken from https://github.com/component/throttle v1.0.0
 *
 * @param {Function} func Function to wrap.
 * @param {Number} wait Number of milliseconds that must elapse between `func` invocations.
 * @return {Function} A new function that wraps the `func` function passed in.
 */
export default function throttle(func, wait) {
    var ctx;
    var args;
    var rtn;
    var timeoutID;
    var last = 0;
    function call() {
        timeoutID = 0;
        last = +new Date();
        rtn = func.apply(ctx, args);
        ctx = null;
        args = null;
    }
    return function throttled() {
        ctx = this;
        args = arguments;
        var delta = new Date().getTime() - last;
        if (!timeoutID) {
            if (delta >= wait) {
                call();
            }
            else {
                // @ts-ignore
                timeoutID = setTimeout(call, wait - delta);
            }
        }
        return rtn;
    };
}
//# sourceMappingURL=throttle.js.map